module.exports = require("@splunk/dashboard-visualizations/SingleValueRadial");